function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/folder-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5kveost08a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/folder-add (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h21v21H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/folder-add (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h21v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/folder-add",
    style: {
      clipPath: "url(#5kveost08a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/folder-add (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/folder-add (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h21v21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.67 15.453H.736A.746.746 0 0 1 0 14.7V.754A.746.746 0 0 1 .736 0h5.849a.184.184 0 0 1 .126.052l2.7 2.643h8.26a.746.746 0 0 1 .736.754V14.7a.746.746 0 0 1-.737.753zM1.657 1.7v12.057h15.092V4.391h-8L5.994 1.7zm8.03 9.893H8.72a.166.166 0 0 1-.162-.166v-2H6.615a.171.171 0 0 1-.172-.166v-.992a.169.169 0 0 1 .172-.169h1.943v-2a.167.167 0 0 1 .162-.167h.967a.164.164 0 0 1 .161.167v2h1.944a.17.17 0 0 1 .173.166v.989a.172.172 0 0 1-.173.166H9.848v2a.164.164 0 0 1-.161.168z",
    transform: "translate(1.297 2.773)",
    style: {
      fill: "#current"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2c0b818839132229e2d91dd1b7b96919.svg";
export { ForwardRef as ReactComponent };